import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbMediaBreakpointsService,
  NbThemeService,
  NbToastrService,
} from "@nebular/theme";

import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Catalog, Product } from "../../models/product.model";

import { ProductService } from "../../services/product.service";

import { DialogProductComponent } from "../dialog-product/dialog-product.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import * as _ from "lodash";
import Shop from "../../models/shop.model";
import { ShopService } from "../../services/shop.service";
import { DialogPrintProductsComponent } from "../dialog-print-products/dialog-print-products.component";
import { environment } from "../../../environments/environment";

@Component({
  selector: "ngx-view-products",
  styleUrls: ["./view-products.component.scss"],
  templateUrl: "./view-products.component.html",
})
export class ViewProductsComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "";
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];
  @Input() products?: Product[] = [];
  product: Product = new Product();

  loading = false;
  submitted = false;

  @ViewChild("title") title: ElementRef;
  @ViewChild("price") price: ElementRef;
  isMoreInfo = true;
  uid = "anonymous";
  user: User;
  page: number = 1;
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private shopService: ShopService,
    private router: Router,
    private dialogService: NbDialogService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          if (!this.shopId) {
            this.shopId = user.shopId ? user.shopId : user.uid;
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();
    }, 1000);
  }

  onNew() {
    this.product.isStock = true;
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Tạo mặt hàng",
          user: this.user,
          mode: "new",
          product: this.product,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
          products: this.products,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.initNewProduct();
        }
      });
  }

  onEdit(item: Product) {
    if (item) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == item.id) {
          this.products[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    remove(this.products, (e) => {
      return e.id == value;
    });
  }

  //Quick create product
  initNewProduct() {
    let newProd = new Product();
    newProd.shopId = this.shopId;
    newProd.title = "";
    newProd.price = null;
    newProd.unitId = this.product.unitId;
    newProd.unitName = this.product.unitName;
    newProd.groupId = this.product.groupId;
    newProd.groupName = this.product.groupName;
    newProd.categoryId = this.product.categoryId;
    newProd.categoryName = this.product.categoryName;
    newProd.isStock = true;
    this.product = newProd;
    this.price.nativeElement.value = "";
    this.title.nativeElement.focus();
  }

  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputPrice() {
    if (this.isMoreInfo) {
      this.price.nativeElement.focus();
    }
  }

  removeCatalog(cat) {
    switch (cat) {
      case "units":
        this.product.unitId = "";
        break;
      case "groups":
        this.product.groupId = "";
        break;
      case "categories":
        this.product.categoryId = "";
        break;
      case "suppliers":
        this.product.supplierId = "";
        break;
      case "producers":
        this.product.producerId = "";
        break;
      case "origins":
        this.product.originId = "";
        break;
      case "sizes":
        this.product.sizeId = "";
        break;
      case "colors":
        this.product.colorId = "";
        break;
      default:
        break;
    }
  }

  create() {
    this.product.title = this.product.title ? this.product.title.trim() : "";
    this.product.price = this.product.price
      ? parseFloat(this.product.price.toString())
      : 0;

    if (this.product.title.length > 0) {
      this.product.unitId = this.product.unitId ? this.product.unitId : "";
      const unit = _.find(this.units, { id: this.product.unitId });
      this.product.unitName = unit ? unit.title : "Cái";
      this.product.groupId = this.product.groupId ? this.product.groupId : "";
      this.product.groupName = _.find(this.groups, {
        id: this.product.groupId,
      })?.title;
      this.product.categoryId = this.product.categoryId
        ? this.product.categoryId
        : "";
      this.product.categoryName = _.find(this.categories, {
        id: this.product.categoryId,
      })?.title;

      this.loading = true;
      this.submitted = true;
      this.productService
        .create(this.product)
        .then((data) => {
          this.initNewProduct();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    } else {
      this.title.nativeElement.focus();
    }
  }

  printProducts() {
    this.dialogService
      .open(DialogPrintProductsComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          products: this.products,
          shop: this.shop,
          showSelection: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }
}
